// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Map from "../../../../../../../node_modules/rescript/lib/es6/map.js";
import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Caml_obj from "../../../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Caml_array from "../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Pervasives from "../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_js_exceptions from "../../../../../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";

function fromString(admin_config) {
  var compare = Caml_obj.caml_compare;
  var AdminConfigMap = $$Map.Make({
        compare: compare
      });
  var data = window.decodeURIComponent(admin_config);
  var admin_config_map = List.fold_left((function (admin_config_map, data) {
          var config_lst = data.split("=");
          var match = config_lst.length;
          if (match === 0 || match === 1) {
            return admin_config_map;
          } else {
            return Curry._3(AdminConfigMap.add, Caml_array.get(config_lst, 0), Caml_array.get(config_lst, 1), admin_config_map);
          }
        }), AdminConfigMap.empty, $$Array.to_list(data.split("&")));
  var value;
  try {
    value = Curry._2(AdminConfigMap.find, "use_new_order_detail", admin_config_map);
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === "Not_found") {
      return {
              use_new_order_detail: undefined
            };
    }
    throw exn;
  }
  return {
          use_new_order_detail: Pervasives.bool_of_string(value)
        };
}

function adminConfig_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var admin_config = Decco.optionFromJson(adminConfig_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "admin_config"), null));
  if (admin_config.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              admin_config: admin_config._0
            }
          };
  }
  var e = admin_config._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".admin_config" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  fromString ,
  adminConfig_decode ,
  t_decode ,
  
}
/* No side effect */
